import React, { ReactNode } from 'react'

import { getChainById, Token } from 'symbiosis-js-sdk'
import { Icons } from 'symbiosis-js-sdk/dist/constants'
import classNames from 'classnames'

import NoneIcon from '~/assets/icons/token-unknown.png'

import SynthIcon from './assets/icon-synth.png'

import css from './Asset.pcss'

type IconType = keyof Icons

interface AssetProps {
	token?: Token
	icon?: IconType
	placeholder?: string
	minimal?: boolean
	onClick?: () => void
	disabled?: boolean
	after?: ReactNode
	className?: string
}

const NoneIcons: Icons = {
	large: NoneIcon,
	small: NoneIcon,
}

const onImageLoadError = ({ currentTarget }) => {
	currentTarget.onerror = null
	currentTarget.src = NoneIcon
}

const Asset: React.FC<AssetProps> = ({
	token,
	icon = 'small',
	minimal,
	onClick,
	disabled,
	after,
	className,
	placeholder = 'none',
}) => {
	const chain = getChainById(token.chainId)
	const chainFrom = getChainById(token.chainFromId)

	return (
		<div
			className={classNames(
				css.asset,
				{
					[css.isMinimal]: minimal,
					[css.isSynth]: token?.isSynthetic,
					[css.isClickable]: !!onClick,
					[css.isDisabled]: disabled,
					[css.isNone]: !token,
				},
				className
			)}
			title={chainFrom ? `Minted from ${chainFrom.name}` : ''}
			onClick={onClick}
			role="presentation"
			data-qa="asset"
		>
			<div className={css.inner}>
				{token && (
					<div className={classNames(css.icons, css.withChainFrom)}>
						<img
							className={css.token}
							src={(token.icons || NoneIcons)?.[icon]}
							alt={token.name}
							onError={onImageLoadError}
						/>
						<img
							className={css.chain}
							src={chain!.icons?.[icon]}
							alt={chain!.name}
							onError={onImageLoadError}
						/>
					</div>
				)}
				<div
					className={classNames(css.info, {
						[css.infoEmpty]: !token,
					})}
				>
					<div className={css.name}>
						{token ? token.symbol : placeholder}
						{token?.isSynthetic && (
							<img
								src={SynthIcon}
								className={css.synth}
								alt={token.name}
							/>
						)}
					</div>
					{/*{chainFrom && (*/}
					{/*    <div className={css.from}>From: {chainFrom.name}</div>*/}
					{/*)}*/}
				</div>
				{after && <div className={css.after}>{after}</div>}
			</div>
		</div>
	)
}

export default Asset
